//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Gateway.js";
import "../no/Builder.js";
let d=[[[0,"AccuracyType",1,0],[0,"ComponentGroupName",1,0],[0,"MarkerColorOfAllComponents",1,0],[0,"MarkerColorOfDisplayedPart",1,0],[0,"MarkerColorOfSelectedComponentSet",1,0],[0,"MarkerColorOfSelectedComponents",1,0],[0,"UseAllComponents",1,0],[0,"UseDisplayedPart",1,0],[0,"UseSelectedComponentSet",1,0],[0,"UseSelectedComponents",1,0],[0,"UseSourceHierarchy",1,0]],[[["numSources","variableSources"],"GetSourceHierarchy",{},0,0],[["variableSources"],"SetSourceHierarchy",{},1,0]],[]];
SPLM.Gateway.MassPropertyOptionsBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Gateway.MassPropertyOptionsBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Gateway.MassPropertyOptionsBuilder.AccuracyTypes = Object.freeze({
    "Value1" : "Value1", "Value2" : "Value2", "Value3" : "Value3", "Value4" : "Value4", "Value5" : "Value5", "Value6" : "Value6"});

export default SPLM;